import { featuredProducts, formatBRL, lowestFeaturedPrice, PARTNER_ID, YBERA_HOST, pixAmount } from "@/lib/catalog";

export const SITE_URL = "https://progressivafashionloja.com";
export const BUSINESS_NAME = "Fashion Gold Loja";
export const BUSINESS_LEGAL_NAME = "Fashion Gold Loja — parceiro oficial Ybera Paris";
export const BUSINESS_EMAIL = "contato@progressivafashionloja.com";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-fashion-gold.jpg`;
export const YBERA_AFFILIATE_HOME = `https://${YBERA_HOST}/?parceiro=${PARTNER_ID}`;

export function yberaSearchUrl(query: string): string {
  const slug = encodeURIComponent(query.trim());
  return `https://${YBERA_HOST}/busca/${slug}?parceiro=${PARTNER_ID}`;
}
export const B2C_LEGAL_NAME = "B2C BRASIL INTERMEDIACOES LTDA";
export const B2C_CNPJ = "35.689.522/0001-27";
export const B2C_ADDRESS =
  "Av. Alcacibas Furtado Nº 800, Complemento: 03, Modulo 11, Pátio 02, CLGV - Bairro: Canaã - Cidade: Viana - ES - CEP: 29.135-008";
export const B2C_DISCLAIMER = `Parceiro oficial ${B2C_LEGAL_NAME} - ${B2C_CNPJ} - Distribuidor Oficial do Brasil | ${B2C_ADDRESS} As imagens, textos e layout aqui veiculados são de propriedade da Loja. É proibida a utilização total ou parcial sem nossa autorização.`;

export const PARTNER_HERO_CLOSE =
  "Escolha o produto e compre na loja oficial Ybera com nosso desconto especial de parceiro oficial.";

export function partnerBuyFaq(brand?: string): string {
  const who = brand ? `Ybera Group (${brand})` : "Ybera Group";
  return `Somos parceiro oficial Ybera. Escolha o produto e toque em Comprar na Ybera: você conclui o pedido na loja oficial com nosso desconto especial. Pagamento, estoque e nota fiscal são da ${who}. Confira o CNPJ 35.689.522/0001-27 ou 14.402.098/0001-18 na nota.`;
}

export const SNIPPET_PRICE_FROM = formatBRL(lowestFeaturedPrice());

export const DEFAULT_TITLE =
  "Progressiva Fashion Gold sem formol | Parceiro oficial Ybera";
export const DEFAULT_DESCRIPTION = `Compre a Progressiva Fashion Gold Ybera Paris sem formol. Escova 300g e 500g, kits e manutenção. A partir de ${SNIPPET_PRICE_FROM}. Parceiro oficial: desconto especial na loja Ybera.`;

export const HUB_PATHS = {
  home: "/",
  progressiva: "/progressiva-fashion-gold/",
  progressivaOficial: "/progressiva-fashion-gold-oficial/",
  cronograma: "/cronograma-capilar-fashion-gold/",
  oleoMirra: "/oleo-de-mirra-ybera/",
  antiqueda: "/100timetros-antiqueda-capilar-fashion-gold/",
  soroVello: "/soro-vital-vello-ybera-paris/",
  perfume: "/perfume-ana-castela-boiadeira-fashion-gold/",
} as const;

export function productPath(slug: string): string {
  return `/produto/${slug}/`;
}

export function productCanonical(slug: string): string {
  return `${SITE_URL}${productPath(slug)}`;
}

export function featuredOfferLabel(): string {
  const product = featuredProducts()[0];
  if (!product?.price) return SNIPPET_PRICE_FROM;
  return formatBRL(pixAmount(product.price));
}
